import React, { useEffect, useState, useMemo } from 'react'
import { MenuItem, TextField, SxProps, Theme } from '@mui/material'
import { useZones } from '../../../hooks'
import { Zone } from '../../../interfaces'

interface ZoneDDLProps {
  value: any
  onChange: any
  variant?: 'outlined' | 'filled' | 'standard'
  fullWidth?: boolean
  warehouseId?: number | null
  required?: boolean
  disabled?: boolean
  isExternal?: boolean | null
  size?: 'small' | 'medium' | undefined
  label?: string
  sx?: SxProps<Theme>
}

export const ZoneDDL: React.FC<ZoneDDLProps> = ({
  onChange,
  value,
  variant = 'standard',
  fullWidth = false,
  warehouseId = null,
  required = false,
  disabled = false,
  isExternal = null,
  size,
  label,
  ...otherProps
}) => {
  const [hasError, setHasError] = useState(false)
  const {
    zonesState: { zones },
    getZones
  } = useZones()

  // Si no hay zonas, las cargamos
  useEffect(() => {
    if (zones?.length === 0) {
      getZones()
    }
  }, [])

  // Validación de error
  useEffect(() => {
    setHasError(required && value === -1)
  }, [value, required])

  // Memoizamos para no recalcular en cada render innecesariamente
  const filteredZones = useMemo<Zone[]>(() => {
    if (!zones) return []

    let result = zones.filter((z) => z.active)

    // Si me pasaron warehouseId (ni null ni undefined), filtro por él
    if (warehouseId != null) {
      result = result.filter((z) => z.warehouseId === warehouseId)
    }

    // Si me pasaron isExternal, filtro por ese booleano
    if (isExternal != null) {
      result = result.filter((z) => z.externalStorage === isExternal)
    }

    return result
  }, [zones, warehouseId, isExternal])

  return (
    <TextField
      id='zoneId'
      name='zoneId'
      select
      label={label}
      value={value === '' ? -1 : value}
      onChange={onChange}
      variant={variant}
      fullWidth={fullWidth}
      error={hasError}
      helperText={hasError ? 'Seleccionar Zona' : undefined}
      disabled={disabled}
      size={size}
      {...otherProps}
    >
      <MenuItem key={-1} value={-1}>
        Seleccionar Zona...
      </MenuItem>

      {filteredZones.map((z) => (
        <MenuItem key={z.zoneId} value={z.zoneId}>
          {z.zoneName}
        </MenuItem>
      ))}
    </TextField>
  )
}
